import React from 'react'
import {
  Box,
  Dialog as MuiDialog,
  DialogTitle,
  IconButton,
} from '@material-ui/core'
import { X } from 'react-feather'

type Props = {
  children: React.ReactNode
  title: string
  open: boolean
  maxWidth?: false | 'md' | 'xs' | 'sm' | 'lg' | 'xl'
  onClose: () => void
}

export function Dialog({
  children,
  title,
  open,
  onClose,
  maxWidth,
}: Props): React.ReactElement {
  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth ?? 'sm'}
      fullWidth
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between">
          <span>{title}</span>

          <Box mt={-1} mr={-2}>
            <IconButton onClick={onClose}>
              <X />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>

      {children}
    </MuiDialog>
  )
}
